/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

const selfRegister = {
  '': '/self-register',
};

export default selfRegister;
